import { useCaixaAtual } from "../api/caixa";
import { useSessao } from "../api/sessao";
import { Carregando, FalhaAoCarregar } from "../components/Estados";
import { AbrirCaixa } from "./caixa/AbrirCaixa";
import { Pdv } from "./caixa/Pdv";

/** Sem caixa aberto: formulário de abertura. Com caixa aberto: o PDV. */
export function PaginaCaixa() {
  const { data: sessao } = useSessao();
  const atual = useCaixaAtual();
  if (atual.isPending || !sessao) return <Carregando />;
  if (atual.error && atual.data === undefined) {
    return <FalhaAoCarregar erro={atual.error} tentarDeNovo={() => atual.refetch()} />;
  }
  return atual.data ? <Pdv caixa={atual.data} usuario={sessao.usuario} /> : <AbrirCaixa />;
}
